<script setup>
  import { storeToRefs } from "pinia";
  import { useReportsV2Store } from "@stores/survey/reportsV2/reportsV2";
  import { ReportV2Form } from "@/components/Reports/ReportV2Form";

  const reportsStore = useReportsV2Store();
  const { currentReport } = storeToRefs(reportsStore);

  async function handleSubmit(params) {
    try {
      await reportsStore.updateReport(params);
    } catch (error) {
      console.error("Failed to update report:", error);
    }
  }
</script>

<template>
  <div class="p-6">
    <ReportV2Form
      v-if="currentReport"
      mode="edit"
      @submit="handleSubmit" />
  </div>
</template>
